import { render } from "./EmployeeTrainingFileDetail.vue?vue&type=template&id=74df5d7e"
import script from "./EmployeeTrainingFileDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeTrainingFileDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__